export const TEXT_CLASS_PREFIX = 'text-';

export default {
    name: 'QDivider',
    inheritAttrs: false,
    props: {
        align: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        borderColor: {
            type: String,
            default: ''
        }
    },
    computed: {
        propsClasses() {
            return this.color ? TEXT_CLASS_PREFIX + this.color : '';
        }
    }
};
